import React from "react";
import Particles from "react-tsparticles";
import { loadFirePreset } from "tsparticles-preset-fire";

const FireParticles = () => {
  const particlesInit = async (engine) => {
    await loadFirePreset(engine);
  };

  return (
    <Particles
      id="tsparticles"
      init={particlesInit}
      options={{
        preset: "fire",
        fullScreen: { enable: true, zIndex: -1 }, // important to stay behind content
        background: {
          color: {
            value: "#12102f", // match your page background
          },
        },
      }}
    />
  );
};

export default FireParticles;